export default "__VITE_ASSET__Cr60GMHs__"